import { useEffect, useState } from 'react'
import { fullName } from '../../app/utils'
import { VALIDATION_ERROR } from '../../app/errors'
import { ErrorWithString } from '../RegularComponents'

const WorkHistoryDetailsForm = (props) => {

    const id = props.id + "-work-history"
    const [people, setPeople] = useState(props.people)
    const [workDescription, setWorkHistoryDescription] = useState(props.description)

    const [showValidationError,setShowValidationError] = useState(props.showValidationError)

    const [nameError,setNameError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [descriptionError, setDescriptionError] = useState(VALIDATION_ERROR.NO_ERROR)

    useEffect(() => { 
        
        const validateName = () => { 
            if(!people || !people.firstName) {
                setNameError(VALIDATION_ERROR.EMPTY)
            } else { 
                setNameError(VALIDATION_ERROR.NO_ERROR)
            }
        }

        const validateDescription = () => { 
            if(!workDescription) {
                setDescriptionError(VALIDATION_ERROR.EMPTY)
            } else { 
                setDescriptionError(VALIDATION_ERROR.NO_ERROR)
            }
        }

        setPeople(props.people)
        setWorkHistoryDescription(props.description)
        setShowValidationError(props.showValidationError)

        if(props.showValidationError) {
            validateName()
            validateDescription()
        }
    },[props, people, workDescription, setNameError, setDescriptionError, setShowValidationError ])

    const peopleNameOptionElements = []

    peopleNameOptionElements.push(
        <option 
            key={"-1"} 
            value={"select"}>
            {"Select"}
        </option>
    )
    
    props.peopleList.forEach((people) => {

        let nameComponent = []

        let name = fullName(people)

        if(name)
            nameComponent.push(name)

        if(people.position) 
            nameComponent.push(people.position) 

        peopleNameOptionElements.push(
            <option 
                key={people.entityId} 
                value={people.entityId}>
                {nameComponent.join(", ")}
            </option>
        )
    })

    const isNameValid = () => { 
        if(showValidationError) { 
            return (nameError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isDescriptionValid = () => { 
        if(showValidationError) { 
            return (descriptionError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    return (
        <div className="ns-fieldset" id={id + "-form"}>
            <div className={"ns-fieldset" + (!isNameValid() ? " ns-fieldset-message-error" : "")}>
                <label
                    className="ns-label" 
                    id={id + "-people-name-select-label"}
                    htmlFor={id + "-people-name-select-input"}>
                        Name
                </label>
                {!isNameValid() && 
                <span id={id + "-people-name-select-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString("Select a name from the list")}
                </span>
                }
                <div className="select fw-25 inlineDisplay">
                    <select
                        className={!isNameValid() ? "select--error" : ""}
                        style={{width: "25em"}}
                        id={id + "-people-name-select-input"}
                        name={id + "-people-name-select-input"}
                        value={people.entityId}
                        onChange={(e) => {
                                let people = props.peopleList.find((p) => (p.entityId === e.target.value))

                                if(people) {
                                    //people/
                                    setPeople(people)

                                    props.onDetailsChange({
                                        id: props.id,
                                        updatedDetails : {
                                            people : people
                                        }
                                    })
                                }
                            }}>
                            {peopleNameOptionElements}
                    </select>
                </div>
            </div>
            <div className={"ns-fieldset" + (!isDescriptionValid() ? " ns-fieldset-message-error" : "")}>
                <label
                    className="ns-label" 
                    id={id + "-work-description-label"}>
                        Work history
                </label>
                <div className="help-block">
                    Maximum of 1000 characters
                </div>
                {!isDescriptionValid() && 
                <span id={id + "-work-description-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString("Enter a description of the work")}
                </span>}
                <div className={"textarea fw-25 inlineDisplay"}>
                    <textarea
                        className={isDescriptionValid() ? "ns-input" : "ns-input--error"}
                        style={{width: "25em"}}
                        id={id + "-work-description-input"}
                        rows={4} 
                        cols={60}
                        maxLength={1000}
                        value={workDescription || ""}
                        onInput={(e) => {
                            setWorkHistoryDescription(e.target.value)
                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    description : e.target.value
                                }
                            })
                        }}>
                    </textarea>
                </div> 
            </div>
        </div>
    )
}

export default WorkHistoryDetailsForm